<template>
  <div class="consulting_service">
    <div class="service">
      <div class="service_tel">
        <img class="tel_img" src="/static/img/index/telephone.png" alt="">
        官方电话
        <div class="float">
          <div class="float_maker"></div>
          <div class="float_img up_word">0532-86416789</div>
        </div>
      </div>
      <div class="service_weChat">
        <img class="weChat_img" src="/static/img/index/weChat.png" alt="">
        官方微信
        <div class="float">
          <div class="float_maker"></div>
          <img class="float_img up_img" src="/static/img/common/official.png" alt="">
        </div>
      </div>
      <div class="service_micro">
        <img class="micro_img" src="/static/img/index/micro-blog.png" alt="">
        官方抖音
        <div class="float">
          <div class="float_maker"></div>
          <img class="float_img up_img" src="/static/img/common/dou.png" alt="">
        </div>
      </div>
    </div>
    <div class="return_top" @click="goTop">
      <img class="micro_img" src="/static/img/index/return.png" alt="">
    </div>   
  </div> 
</template>

<script>
	export default {
		props: {
			value: {
				type: String,
				default: ''
			}
		},
		data(){
			return {
				
			}
		},
		mounted(){
			var topGo = document.querySelector('.consulting_service') // 获取元素加过度效果 （用ref也可以）
      
      window.addEventListener('scroll',()=>{
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //距离底部高度
      let bottomHeight =  scrollHeight - (scrollTop + windowHeight)
      // 滚动大于500显示
        if(document.documentElement.scrollTop > 300&&bottomHeight>200 ){
            topGo.style.opacity = '1'
            topGo.style.transition = 'all 1s'
        }else{
            topGo.style.opacity = '0'
            topGo.style.transition = 'all 1s'
        }
      })
		},
		methods: {
      goTop(){
        document.documentElement.scrollTop-=30
        if(document.documentElement.scrollTop>0){
          setTimeout(()=>{
            this.goTop()
          },10)
          return
        }else{
          document.documentElement.scrollTop=0
          return
        }
      }
		}
	}
</script>

<style scoped lang="scss">

@media screen and ( min-width: 1200px ) {
  .consulting_service{
    opacity: 0;
    justify-content: center;
    z-index: 99;
    position: fixed;
    right: 2vw;
    bottom: 15vh;
    .service{
      width: 68px;
      height: 209px;
      background: #ffffff;
      border: 1px solid #F9F9FA;
      box-shadow: 0px 4px 4px rgba(249, 249, 250, 0.5);
      border-radius: 100px;
      text-align: center;
      .float{
        position: absolute;
        right: 70px;
        white-space: nowrap;
        display: none;
        flex-direction: row-reverse;
        box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.05);
        .float_maker{
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 12px 0 12px 10px;
          border-color: transparent transparent transparent #ffffff;
        }
        .float_img{
          width: 128px;
          background: #FFFFFF;
          border-radius: 4px;
          padding: 20px 20px;
          box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.05);
          color: #262626;
          font-weight: bold;
          font-size: 14px;
        }
        .up_word{
          position: absolute;
          right: 10px;
          top: -15px;
        }
        .up_img{
          position: absolute;
          right: 10px;
          top: -60px;
        }
      }
      .service_tel{
        margin: 20px 9px 0 9px;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: 12px;
        color: #91959B;
        text-align: center;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #EEF0F3; 
        position: relative;
        .tel_img{
          width: 18px;
          height: 18px;
          margin-bottom: 6px;
        }
      }
      .service_tel:hover{
        .float{
          display: flex;
        }
      }
      .service_weChat{
        margin: 12px 9px 0 9px;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: 12px;
        color: #91959B;
        text-align: center;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #EEF0F3; 
        position: relative;
        .weChat_img{
          width: 18px;
          height: 18px;
          margin-bottom: 6px;
        }
      }
      .service_weChat:hover{
        .float{
          display: flex;
        }
      }
      .service_micro{
        margin: 12px 9px 0 9px;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: 12px;
        color: #91959B;
        text-align: center;
        align-items: center;
        padding-bottom: 10px;
        position: relative;
        .micro_img{
          width: 18px;
          height: 18px;
          margin-bottom: 6px;
        }
      }
      .service_micro:hover{
        .float{
          display: flex;
        }
      }
    }
    .return_top{
      width: 68px;
      height: 68px;
      background: #FFFFFF;
      border: 1px solid #F9F9FA;
      box-shadow: 0px 4px 4px rgba(249, 249, 250, 0.5);
      border-radius: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 11px;
      .micro_img{
        width: 20px;
        height: 17px;
      }
    }
  }
}
@media screen and ( min-width: 1000px ) and ( max-width: 1200px ) {
  .consulting_service{
    opacity: 0;
    justify-content: center;
    z-index: 99;
    position: fixed;
    right: 2vw;
    bottom: 15vh;
    .service{
      width: 4.25rem;
      height: 13.0625rem;
      background: #ffffff;
      border: .0625rem solid #F9F9FA;
      box-shadow: 0rem .25rem .25rem rgba(249, 249, 250, 0.5);
      border-radius: 6.25rem;
      text-align: center;
      .float{
        position: absolute;
        right: 4.375rem;
        white-space: nowrap;
        display: none;
        flex-direction: row-reverse;
        box-shadow: 0px .25rem .875rem rgba(0, 0, 0, 0.05);
        .float_maker{
          width: 0;
          height: 0;
          border-style: solid;
          border-width: .75rem 0 .75rem .625rem;
          border-color: transparent transparent transparent #ffffff;
        }
        .float_img{
          background: #FFFFFF;
          border-radius: .25rem;
          padding: 1.25rem 1.25rem;
        }
      }
      .service_tel{
        margin: 1.25rem .5625rem 0 .5625rem;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: .75rem;
        color: #91959B;
        text-align: center;
        align-items: center;
        padding-bottom: .625rem;
        border-bottom: .0625rem solid #EEF0F3; 
        position: relative;
        .tel_img{
          width: 1.125rem;
          height: 1.125rem;
          margin-bottom: .375rem;
        }
      }
      .service_tel:hover{
        .float{
          display: flex;
        }
      }
      .service_weChat{
        margin: .75rem .5625rem 0 .5625rem;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: .75rem;
        color: #91959B;
        text-align: center;
        align-items: center;
        padding-bottom: .625rem;
        border-bottom: .0625rem solid #EEF0F3; 
        position: relative;
        .weChat_img{
          width: 1.125rem;
          height: 1.125rem;
          margin-bottom: .375rem;
        }
      }
      .service_weChat:hover{
        .float{
          display: flex;
        }
      }
      .service_micro{
        margin: .75rem .5625rem 0 .5625rem;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: .75rem;
        color: #91959B;
        text-align: center;
        align-items: center;
        padding-bottom: .625rem;
        position: relative;
        .micro_img{
          width: 1.125rem;
          height: 1.125rem;
          margin-bottom: .375rem;
        }
      }
      .service_micro:hover{
        .float{
          display: flex;
        }
      }
    }
    .return_top{
      width: 68px;
      height: 68px;
      background: #FFFFFF;
      border: 1px solid #F9F9FA;
      box-shadow: 0px 4px 4px rgba(249, 249, 250, 0.5);
      border-radius: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 11px;
      .micro_img{
        width: 20px;
        height: 17px;
      }
    }
  }
}
@media screen and ( max-width: 1000px ) {
  .consulting_service{
    opacity: 0;
    justify-content: center;
    z-index: 99;
    position: fixed;
    right: 2vw;
    bottom: 15vh;
    .service{
      display: none; 
    }
    .return_top{
      width: 2.5rem;
      height: 2.5rem;
      background: #FFFFFF;
      border: .0625rem solid #F9F9FA;
      box-shadow: 0rem .125rem .25rem rgba(14, 160, 72, 0.171);
      border-radius: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: .3125rem;
      .micro_img{
        width: .625rem;
      }
    }
  }
}
  
</style>



// WEBPACK FOOTER //
// src/components/backtop.vue